<div
  [formGroup]="form"
  class="d-flex flex-column align-items-center justify-content-center h-full"
>
  <dges-login-form formControlName="loginForm"></dges-login-form>
  <div class="login-dialog-actions">
    <button mat-raised-button (click)="login()">Login</button>
    <button mat-stroked-button (click)="loginWithGoogle()">
      Sign in with Google
    </button>
  </div>
</div>
